<template>
  <v-container>
    <v-card>
      <input
        id="user-id"
        type="hidden"
        v-model="pessoa.usuario"
      />
      <input
        id="pessoa-id"
        type="hidden"
        v-model="pessoa.id"
      />
      <input
        id="pessoa-uuid"
        type="hidden"
        v-model="pessoa.uuid"
      />
      <v-row class="px-2">
        <v-col
          cols="12"
          lg="3"
          md="4"
          sm="12"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            outlined
            dense
          >
            <v-icon
              slot="append"
              color="success"
              large
              @click="loadDialog"
            >
              mdi-magnify
            </v-icon>
          </v-text-field>
        </v-col>
        <v-col
          colls="12"
          lg="2"
          md="3"
          sm="6"
        >
          <v-card-text class="py-0 mt-0">CPF/ CNPJ<h4>{{ pessoa.cgc_txt }}</h4>
          </v-card-text>
        </v-col>
        <v-col
          cols="12"
          lg="3"
          md="3"
          sm="6"
          v-if="codigo"
        >
          <v-checkbox
            v-model="pessoa.inativar"
            label="Inativar fornecedor?"
            color="success"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="12"
          lg="2"
          md="2"
          sm="6"
          v-if="codigo"
        >
          <v-btn
            color="default"
            @click.prevent="altPass"
          >
            <v-icon
              left
              color="green"
            >
              mdi-account-key
            </v-icon>
            Redefinir senha
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="px-2">
        <v-col
          cols="12"
          lg="3"
          md="6"
          sm="12"
        >
          <v-autocomplete
            v-model="pessoa.tipo_pessoa"
            :items="tPessoa"
            label="Tipo de pessoa"
            required
            outlined
            dense
            @change="loadFuncaoPessoa()"
          ></v-autocomplete>
        </v-col>
        <input
          id="pessoa-cgc"
          type="hidden"
          v-model="pessoa.cgc"
        />
        <v-col
          cols="12"
          lg="3"
          md="6"
          sm="12"
          v-if="verCpf === true"
        >
          <v-text-field
            v-model="pessoa.cgc_txt"
            :color="color"
            v-mask="cpf"
            name="cpf"
            label="CPF"
            type="text"
            outlined
            dense
            required
            @blur="formataCpf()"
          >
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          lg="3"
          md="6"
          sm="12"
          v-if="verCnpj === true"
        >
          <v-text-field
            v-model="pessoa.cgc_txt"
            :color="color"
            v-mask="cnpj"
            type="text"
            label="CNPJ"
            outlined
            dense
            required
            @blur="formataCnpj()"
          >
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          lg="3"
          md="6"
          sm="12"
        >
          <v-autocomplete
            v-model="pessoa.natureza"
            :items="natureza"
            label="Natureza Jurídica"
            required
            outlined
            dense
          ></v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          lg="3"
          md="6"
          sm="12"
        >
          <v-autocomplete
            v-model="pessoa.tp_cadastro"
            :items="tp_cadastro"
            label="Tipo de cadastro"
            required
            outlined
            dense
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="px-2">
        <v-col
          cols="12"
          lg="6"
          md="7"
          sm="12"
        >
          <v-text-field
            v-model="pessoa.nome"
            type="text"
            required
            :label="`${nameLabel}`"
            outlined
            dense
          >
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          lg="6"
          md="7"
          sm="12"
          v-if="tipo === 'pjuridica'"
        >
          <v-text-field
            v-model="pessoa.fantasia"
            type="text"
            label="Nome fantasia"
            outlined
            dense
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-card flat>
        <v-tabs
          background-color="primary"
          dark
          v-model="tabs"
          class="mb-4"
        >
          <v-tab>
            <v-icon class="mr-1">
              mdi-file-document-edit-outline
            </v-icon>
            Documentação
          </v-tab>
          <v-tab @click="loadEndereco">
            <v-icon class="mr-1">
              mdi-map-marker-outline
            </v-icon>
            Endereço
          </v-tab>
          <v-tab @click="loadClassificacao">
            <v-icon class="mr-1">
              mdi-shape-outline
            </v-icon>
            Classificação
          </v-tab>
          <v-tab @click="loadPFisica">
            <v-icon class="mr-1">
              mdi-account-outline
            </v-icon>
            Pessoa física
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="3"
                        md="4"
                        sm="6"
                      >
                        <v-text-field
                          v-model="pessoa.ie"
                          type="text"
                          label="Inscrição estadual"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="2"
                        md="4"
                        sm="6"
                      >
                        <v-autocomplete
                          v-model="pessoa.uf_insc"
                          :items="ufinsc"
                          label="UF Inscrição"
                          required
                          outlined
                          dense
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="4"
                        sm="6"
                      >
                        <v-text-field
                          v-model="pessoa.im"
                          type="text"
                          label="Incrição Municipal"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="5"
                        md="7"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.responsavel"
                          type="text"
                          label="Nome do responsável"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="5"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.cargo_responsavel"
                          type="text"
                          label="Cargo"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="3"
                        md="3"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="pessoa.uf"
                          :items="estados"
                          label="Estado"
                          required
                          outlined
                          dense
                          @change="loadCidades()"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                      >
                        <v-autocomplete
                          clearable
                          v-model="pessoa.cidade"
                          :items="cidades"
                          label="Cidade"
                          required
                          outlined
                          dense
                          :disabled="!pessoa.uf"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="3"
                        sm="12"
                      >
                        <v-text-field
                          v-mask="cep"
                          v-model="pessoa.cep"
                          type="text"
                          label="Cep"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class='px-2'>
                      <v-col
                        cols="12"
                        lg="9"
                        md="9"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.bairro"
                          type="text"
                          label="Bairro"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="10"
                        md="8"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.rua"
                          type="text"
                          label="Rua/ Avenida"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="2"
                        md="4"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.numero"
                          type="text"
                          label="Número"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.complemento"
                          type="text"
                          label="Complemento"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.ponto_referencia"
                          type="text"
                          label="Ponto de referência"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                      >
                        <v-autocomplete
                          clearable
                          v-model="pessoa.tipo_residencia"
                          :items="tpResidencia"
                          label="Tipo de imóvel"
                          required
                          outlined
                          dense
                          @change="loadFuncaoResidencia()"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="4"
                        md="4"
                        sm="12"
                        v-if="res === 'financiada' || res==='alugada'"
                      >
                        <v-text-field
                          v-model="pessoa.valor"
                          currency="BRL"
                          label="Valor.:"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="12"
                        md="12"
                        sm="12"
                        v-if="res === 'outros' || res==='cedida'"
                      >
                        <v-text-field
                          v-model="pessoa.ds_outros"
                          type="text"
                          :label="`${dsLabel}`"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="pessoa.tipo_instituicao"
                          :items="instituicao"
                          label="Tipo de instituição"
                          required
                          outlined
                          dense
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="pessoa.area_atuacao"
                          :items="atuacao"
                          label="Àrea de atuação"
                          required
                          outlined
                          dense
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card
                    flat
                    class="py-2"
                  >
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="3"
                        md="4"
                        sm="6"
                      >
                        <v-autocomplete
                          v-model="pessoa.nacionalidade"
                          :items="nacionalidade"
                          label="Nacionalidade"
                          required
                          outlined
                          dense
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="4"
                        sm="6"
                      >
                        <v-text-field
                          v-model="pessoa.rg"
                          type="text"
                          label="Rg"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="4"
                        sm="6"
                      >
                        <v-text-field
                          v-model="pessoa.orgao_expedidor"
                          type="text"
                          label="Orgão expedidor"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="3"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.nis"
                          type="text"
                          label="NIS:"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="3"
                        md="6"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.data_nascimento"
                          type="date"
                          label="Data de Nascimento :"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="6"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="pessoa.estado_civil"
                          :items="estadoCivil"
                          label="Estado civil"
                          required
                          outlined
                          dense
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="6"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="pessoa.genero"
                          :items="genero"
                          label="Gênero"
                          required
                          outlined
                          dense
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="6"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="pessoa.raca"
                          :items="raca"
                          label="Raça/cor"
                          required
                          outlined
                          dense
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row class="px-2">
                      <v-col
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="pessoa.escolaridade"
                          :items="instrucao"
                          label="Escolaridade"
                          required
                          outlined
                          dense
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                      >
                        <v-text-field
                          v-model="pessoa.profissao"
                          type="text"
                          label="Profissão :"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions class="justify-start py-1">
          <v-card-actions>
            <v-btn
              v-if="!codigo"
              class="my-2"
              @click="save"
              color="success"
            >
              Salvar
            </v-btn>
            <v-btn
              v-if="codigo"
              class="my-2"
              @click="update"
              color="success"
            >
              Atualizar
            </v-btn>
            <v-btn
              class="ml-2"
              color="blue-grey"
              @click="reset"
            >
              Limpar
            </v-btn>
          </v-card-actions>
        </v-card-actions>
      </v-card>
    </v-card>
    <v-card>
      <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        fullscreen
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Pesquisar fornecedores cadastrados
            </v-toolbar>
            <v-card-title>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="pesquisar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="filtro"
              :search="search"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  medium
                  color="primary"
                  class="mr-2"
                  @click="loadPessoaFilter(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  medium
                  color="error"
                  class="mr-2"
                  @click="loadPessoaFilter(item, 'remove')"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
            <v-card-actions class="justify-end">
              <v-btn
                color="error"
                @click="dialog.value = false"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-card>
    <v-card class="px-5">
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="editPass"
            transition="dialog-top-transition"
            max-width="470"
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Redefinição de senha
                </v-toolbar>
                <div class="form-pass mx-auto mt-1">
                  <v-form>
                    <v-row
                      justify="space-around"
                      class="px-6 mx-6"
                    >
                      <v-col cols="12">
                        <v-text-field
                          class="py-1 text-field"
                          v-model="pass.password"
                          label="Nova senha"
                          type="password"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          class="py-1 text-field"
                          v-model="pass.confirmPassword"
                          label="Confime a senha"
                          type="password"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end py-6">
                  <v-btn
                    color="success"
                    class="mr-4"
                    @click.prevent="updatePass()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false, loadClose()"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { uuid } from 'vue-uuid'
import { mapState } from 'vuex'
const { cpf, cnpj } = require('cpf-cnpj-validator')
export default {
  name: 'CadFornecedor',
  components: {},
  computed: mapState(['user']),
  data: () => ({
    tabs: false,
    dialog: false,
    editPass: false,
    search: '',
    uuid: '',
    verCpf: false,
    verCnpj: false,
    valid: true,
    codigo: '',
    btnSave: false,
    tipo: 'pfisica',
    res: '',
    vLabel: '',
    dsLabel: '',
    nameLabel: '',
    color: 'null',
    cpf: '###.###.###-##',
    val: '999.999,99',
    cpfMae: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    fone: '(##)####-####',
    cel: '(##)#####-####',
    cep: '##.###-###',
    pessoa: {},
    pass: {},
    tPessoa: [],
    selected: 1,
    raca: [],
    instrucao: [],
    instituicao: [],
    natureza: [],
    tp_cadastro: [],
    atuacao: [],
    filtro: [],
    show1: false,
    show2: true,
    password: 'Password',
    rules: {
      required: value => !!value || 'Este campo é obrigatório',
      min: v => v.length >= 6 || 'A senha deve conter pelo menos 6 caracteres',
      emailMatch: () => (`A cofirmação é diferente da senha!`)
    },
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'E-mail', value: 'email' },
      { text: 'Cpf / Cgc', value: 'cgc_txt' },
      { text: 'Rg', value: 'rg' },
      { text: 'Nis', value: 'nis' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    genero: [
      { value: 'M', text: 'Masculino' },
      { value: 'F', text: 'Feminino' }
    ],
    estadoCivil: [
      { value: 'Solteiro', text: 'Solteiro' },
      { value: 'Casado', text: 'Casado' },
      { value: 'Divorciado', text: 'Divorciado' },
      { value: 'Viúvo', text: 'Viúvo' }
    ],
    tpResidencia: [
      { value: 'PQ', text: 'Própria quitada' },
      { value: 'Pf', text: 'Própria financiada' },
      { value: 'Pa', text: 'Alugada' },
      { value: 'Cd', text: 'Cedida' },
      { value: 'Ot', text: 'Outros' }
    ],
    estados: [],
    ufinsc: [],
    cidades: [],
    nacionalidade: [
      { value: 'BR', text: 'Brasileira' },
      { value: 'BN', text: 'Brasileira - Naturalizado' },
      { value: 'ES', text: 'Estrangeira' }
    ]
  }),
  methods: {
    save () {
      axios.post(`${baseApiUrl}/fornecedores`, this.pessoa)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    update () {
      const id = this.pessoa.uuid
      axios.put(`${baseApiUrl}/fornecedor-update/${id}`, this.pessoa)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    updatePass () {
      const id = this.pessoa.uuid
      axios.put(`${baseApiUrl}/fornecedor-update-pass/${id}`, this.pass)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.editPass = false
        })
        .catch(showError)
    },
    reset () {
      this.pessoa = {}
      this.codigo = ''
      this.tpRes = ''
      this.pessoa.tipo_pessoa = 1
      this.loadFuncaoPessoa()
      this.loadFuncaoResidencia()
      this.pessoa.uuid = uuid.v1()
      this.pessoa.esic = true
      this.pessoa.auxilio = true
      this.btnSave = false
    },
    formataCpf () {
      const cpff = this.pessoa.cgc_txt
      const ccpf = cpf.isValid(cpff)
      const number = cpf.strip(cpff)
      if (ccpf === true) {
        this.pessoa.cgc = number
        this.color = `border: solid 1px #3277d2`
        this.btnSave = true
      } else {
        this.color = `border: solid 1px #FF0000 !important`
      }
    },
    formataCnpj () {
      const cnpjj = this.pessoa.cgc_txt
      const ccnpj = cnpj.isValid(cnpjj)
      const number = cnpj.strip(cnpjj)
      if (ccnpj === true) {
        this.pessoa.cgc = number
        this.color = `border: solid 1px #3277d2`
        this.btnSave = true
      } else {
        this.color = `border: solid 1px #FF0000 !important`
      }
    },
    loadFuncaoPessoa () {
      let codigo = this.codigo
      let pessoa = this.pessoa.tipo_pessoa
      if (pessoa === 1) {
        if (codigo === '') {
          this.verCpf = true
        } else {
          this.verCpf = false
        }
        this.verCnpj = false
        this.tipo = 'pfisica'
        this.nameLabel = 'Nome.'
      } else if (pessoa === 2) {
        if (codigo === '') {
          this.verCnpj = true
        } else {
          this.verCnpj = false
        }
        this.verCpf = false
        this.tipo = 'pjuridica'
        this.nameLabel = 'Razão social.'
        this.loadInstituicao()
        this.loadAtuacao()
      }
    },
    loadFuncaoResidencia () {
      const tpRes = this.pessoa.tipo_residencia
      if (tpRes === 'Pf') {
        this.res = 'financiada'
        this.vLabel = 'Valor do financiamento.'
      } else if (tpRes === 'Pa') {
        this.res = 'alugada'
        this.vLabel = 'Valor do Aluguel.'
      } else if (tpRes === 'Cd') {
        this.res = 'cedida'
        this.dsLabel = 'Cedida por quem?.'
      } else if (tpRes === 'Ot') {
        this.res = 'outros'
        this.dsLabel = 'Descreva.'
      } else {
        this.res = ''
      }
    },
    loadPFisica () {
      this.loadInstrucao()
      this.loadRaca()
    },
    loadPessoa () {
      const url = `${baseApiUrl}/tipo-de-pessoa`
      axios.get(url).then(res => {
        this.tPessoa = res.data.map(tPessoa => {
          return {
            value: tPessoa.id,
            text: `${tPessoa.id} - ${tPessoa.tipo}`
          }
        })
      })
    },
    loadInstrucao () {
      const url = `${baseApiUrl}/escolaridade`
      axios.get(url).then(res => {
        this.instrucao = res.data.map(instrucao => {
          return {
            value: instrucao.id,
            text: `${instrucao.id} - ${instrucao.escolaridade}`
          }
        })
      })
    },
    loadRaca () {
      const url = `${baseApiUrl}/raca`
      axios.get(url).then(res => {
        this.raca = res.data.map(raca => {
          return {
            value: raca.id,
            text: `${raca.id} - ${raca.raca}`
          }
        })
      })
    },
    loadClassificacao () {
      this.loadInstituicao()
      this.loadAtuacao()
    },
    loadInstituicao () {
      const url = `${baseApiUrl}/tipo-de-instituicao`
      axios.get(url).then(res => {
        this.instituicao = res.data.map(instituicao => {
          return {
            value: instituicao.id,
            text: `${instituicao.id} - ${instituicao.instituicao}`
          }
        })
      })
    },
    loadAtuacao () {
      const url = `${baseApiUrl}/area-de-atuacao`
      axios.get(url).then(res => {
        this.atuacao = res.data.map(atuacao => {
          return {
            value: atuacao.id,
            text: `${atuacao.id} - ${atuacao.atuacao}`
          }
        })
      })
    },
    loadNatureza () {
      const url = `${baseApiUrl}/natureza-juridica`
      axios.get(url).then(res => {
        this.natureza = res.data.map(item => {
          return {
            value: item.id,
            text: item.natureza
          }
        })
      })
    },
    loadTpCadastro () {
      const url = `${baseApiUrl}/tipo-de-cadastro`
      axios.get(url).then(res => {
        this.tp_cadastro = res.data.map(item => {
          return {
            value: item.id,
            text: item.tp_cadastro
          }
        })
      })
    },
    loadEndereco () {
      this.loadEstados()
    },
    loadEstados () {
      const url = `${baseApiUrl}/estados`
      axios.get(url).then(res => {
        this.estados = res.data.map(estados => {
          return {
            value: estados.sigla,
            text: estados.nome
          }
        })
      })
    },
    loadUf () {
      const url = `${baseApiUrl}/estados`
      axios.get(url).then(res => {
        this.ufinsc = res.data.map(estados => {
          return {
            value: estados.sigla,
            text: estados.sigla
          }
        })
      })
    },
    loadCidades () {
      const uf = this.pessoa.uf
      const url = `${baseApiUrl}/estados/${uf}`
      axios.get(url).then(res => {
        this.cidades = res.data
      })
    },
    loadFiltro () {
      const url = `${baseApiUrl}/filtro-fornecedores`
      axios.get(url).then(res => {
        this.filtro = res.data
      })
    },
    loadPessoaFilter (filtro, mode = 'save') {
      this.codigo = filtro.id
      const id = filtro.uuid
      this.mode = mode
      const url = `${baseApiUrl}/filtro-update-fornecedores/${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.dialog = false
        this.valid = true
        this.loadFuncaoResidencia()
        this.loadFuncaoPessoa()
        this.loadCidades()
      })
      console.log(filtro)
    },
    altPass () {
      this.editPass = true
    },
    loadDialog () {
      this.dialog = true
      this.loadFiltro()
    },
    loadUser () {
      this.loadPessoa()
      this.loadTpCadastro()
      this.loadNatureza()
      this.loadUf()
      this.pessoa.usuario = this.user.id
      this.nameLabel = 'Nome.'
      this.pessoa.uuid = uuid.v1()
      this.pessoa.esic = true
      this.pessoa.auxilio = true
      this.pessoa.tipo_pessoa = 1
      this.codigo = ''
      this.loadFuncaoPessoa()
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>
